<template>
  <div>
    <div>
      <div v-if="isShowTitle || isCheckMode" class="flex justify-between items-center mt-8 mb-4">
        <!-- Title -->
        <h5 v-if="isShowTitle && !!sectionTitle" class="flex-1 flex items-center"><i class="dot"></i>{{ sectionTitle }}</h5>
        <div v-else class="flex-1"></div>

        <!-- Controller -->
        <div v-if="isCheckMode && !readonly && !isPrint">
          <vs-button color="secondary" @click="handleAdd"> {{ handleAddName }} </vs-button>
          <vs-button class="ml-4" color="secondary" type="border" @click="handleRemove"> {{ handleRemoveName }} </vs-button>
        </div>
      </div>
      <div>
        <table>
          <colgroup>
            <col width="192px" />
            <col />
            <col width="192px" />
            <col />
          </colgroup>
          <tbody>
            <template v-for="(data, index) in reportPlan">
              <tr>
                <th class="text-center" style="width: 192px;">점검내용(법적근거)</th>
                <td colspan="3"><ml-input class="w-full text-left" v-model="data.content" :readonly="readonly" /></td>
              </tr>
              <tr>
                <th class="text-center" style="width: 192px; max-width: 192px;">{{ positionTitle }}</th>
                <td><ml-input class="w-full text-left" v-model="data.position" :readonly="readonly" /></td>
                <th class="text-center" style="width: 192px; max-width: 192px;">{{ causeTitle }}</th>
                <td><ml-input class="w-full text-left" v-model="data.cause" :readonly="readonly" /></td>
              </tr>
              <tr>
                <th colspan="2">{{ beforeTitle }}</th>
                <th colspan="2">{{ afterTitle }}</th>
              </tr>
              <tr>
                <td colspan="2" style="padding: 10px">
                  <!-- ========== Image ========== -->
                  <div class="upload-content__file">
<!--                    <vs-checkbox v-if="isCheckMode" v-model="data.file1.checked" :style="'position: absolute; top: 0;'" class="mt-2 z-20" />-->
                    <div class="upload-content__content">
<!--                      <img v-if="isPrint" class="w-full h-full printImg" :src="data.file1.thumb" alt="" />-->
                      <div v-if="isPrint && !data.file1.image" class="w-full h-full printImg"></div>
                      <FileUploaderTransparent v-else v-model="data.file1.image" :readonly="readonly" style="background-size: contain; background-repeat: no-repeat" />
                    </div>
                  </div>
                </td>
                <td colspan="2" style="padding: 10px">
                  <!-- ========== Image ========== -->
                  <div class="upload-content__file">
<!--                    <vs-checkbox v-if="isCheckMode" v-model="data.file2.checked" :style="'position: absolute; top: 0;'" class="mt-2 z-20" />-->
                    <div class="upload-content__content">
<!--                      <img v-if="isPrint" class="w-full h-full printImg" :src="data.file2.thumb" alt="" />-->
                      <div v-if="isPrint && !data.file2.image" class="w-full h-full printImg"></div>
                      <FileUploaderTransparent v-else v-model="data.file2.image" :readonly="readonly" style="background-size: contain; background-repeat: no-repeat" />
                    </div>
                  </div>
                </td>
              </tr>

              <!-- 타입별 형태 -->
              <tr v-if="reportType !== 3 ">
                <th class="text-center" style="width: 192px; max-width: 192px;">{{ note1Title }}</th>
                <td><ml-input class="w-full text-left" v-model="data.note1" :readonly="readonly" :placeholder="data.note1_placeholder" /></td>
                <th class="text-center" style="width: 192px; max-width: 192px;">{{ note2Title }}</th>
                <td><ml-input class="w-full text-left" v-model="data.note2" :readonly="readonly" :placeholder="data.note2_placeholder" /></td>
              </tr>
              <template v-else-if="reportType === 3">
                <tr>
                  <th class="text-center" style="width: 192px; max-width: 192px;">{{ note1Title }}</th>
                  <td colspan="3"><ml-input class="w-full text-left" v-model="data.note1" :readonly="readonly" /></td>
                </tr>
                <tr>
                  <th class="text-center" style="width: 192px; max-width: 192px;">{{ note2Title }}</th>
                  <td colspan="3"><ml-input class="w-full text-left" v-model="data.note2" :readonly="readonly" /></td>
                </tr>
              </template>

            </template>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import FileUploaderTransparent from "@/components/FileUploaderTransparent2.vue";

export default {
  name: "ReportPlan",
  components: {FileUploaderTransparent},
  props: {
    isPrint: Boolean,
    readonly: Boolean,
    isCheckMode: {
      type: Boolean,
      default: true,
    },
    value: Array,
    reportPlan: {
      type: Array,
      default: () => [],
    },
    /** 맨 위의 동그라미 제목 표시 여부 */
    isShowTitle: {
      type: Boolean,
      default: true,
    },
    customTitle: {
      type: Boolean,
      default: false,
    },
    sectionTitle: String,
    handleAddName: {
      type: String,
      default: "항목추가",
    },
    handleRemoveName: {
      type: String,
      default: "항목삭제",
    },
    reportType: {
      type: Number,
      default: 1,
    },
  },
  watch: {
    reportPlan: {
      immediate: true,
      deep: true,
      handler(value) {
        if (this.reportPlan && this.reportPlan.length === 0) {
          this.handleAdd();
        }
        this.$emit("input", value);
      },
    },
  },
  computed: {
    positionTitle() {
      switch (this.reportType) {
        case 1: return "위치(시설)";
        case 2:
        default: return "장소";
      }
    },
    causeTitle() {
      switch (this.reportType) {
        default: return "기인물";
      }
    },
    beforeTitle() {
      switch (this.reportType) {
        case 1:
        case 2: return "개선 전";
        case 3: return "사진";

        default: return "개선 전";
      }
    },
    afterTitle() {
      switch (this.reportType) {
        case 1: return "개선 후";
        case 2: return "개선 예시";
        case 3: return "사진";

        default: return "개선 후";
      }
    },
    note1Title() {
      switch (this.reportType) {
        case 1:
        case 2: return "지적사항";
        case 3: return "개선내용 설명";

        default: return "지적사항";
      }
    },
    note2Title() {
      switch (this.reportType) {
        case 1: return "개선내용(계획)";
        case 2: return "개선의견";
        case 3: return "참고자료";

        default: return "개선내용(계획)";
      }
    }

  },
  data() {
    return {
      numberId: 0 < this.reportPlan.length ? this.reportPlan[this.reportPlan.length - 1].id : 0,
    };
  },
  methods: {
    handleAdd() {
      const addData = {
        id: ++this.numberId,
        file1: { },
        file2: { },
        note2_placeholder: this.reportType === 1? "개선조치가 완료되지 않을 시 예산신청 사항이나 공사일정 기록": "",
      };
      this.reportPlan.push(addData);
    },
    handleRemove() {
      this.reportPlan.pop();
    },
  },
}
</script>

<style lang="scss" scoped>
$border: 1px solid #cdcdcd;
table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;

  th,
  td {
    border: 1px solid #cdcdcd;
    text-align: center;
    min-height: 50px;
    height: 50px;
    font-size: 14px;
    padding: 0 5px;
  }
  th {
    background-color: #f9f9f9;
    font-weight: 500;
    padding: 0;
    word-break: keep-all;
  }
  td {
    min-width: 50px;
    word-break: keep-all;
    img {
      display: inline-block;
    }
  }
  .th-background {
    background-color: #f9f9f9;
    white-space: nowrap;
  }
  .check-container {
    padding: 10px 14px 0 14px;
    text-align: left;

    div {
      margin-bottom: 8px;
    }
    img {
      display: inline-block;
      margin-right: 8px;
    }
  }
  .text-left {
    text-align: left;
  }
}

.upload-content__file {
  width: 100%;
  padding-top: 56.25%;
  position: relative;
  border: 1px solid #cdcdcd;
  border-radius: 6px;

  .upload-content__content {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-position: center center;
    background-size: cover;

    .printImg {
      background-color: white;
      border-radius: 6px;
    }
  }
}
</style>
